<div class="ms-Dialog-actions" [hidden]="botonProcesando">
  
    <button *ngIf="!validate" [id]="buttonCancelId" class="ms-Button ms-Dialog-action" type="button" (click)="clickCancelButton()">
      <span class="ms-Button-label">{{labelCancel}}</span>
    </button>
  
    <button *ngIf="validate" [id]="buttonCancelId" class="ms-Button ms-Button--primary" type="button" (click)="clickCancelButton()">
      <span class="ms-Button-label">{{labelCancel}}</span>
    </button>

    <button [id]="buttonSaveId" class="ms-Button ms-Button--primary"
     [disabled]="!frm.valid"
      type="submit">
        <span class="ms-Button-label">
            {{labelSave}}
        </span>
        <i *ngIf="icon" class="ms-Icon" [class]="icon"></i>
    </button>

</div>  
<div class="ms-Spinner" [hidden]="!botonProcesando">
    <div class="ms-Spinner-label">
      {{ labelLoading }}
    </div>
  </div>
